import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { ConfigService } from "src/app/shared/config";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { NotificationService } from "src/app/shared/notification.service";
import { map } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { ActionLog } from '../admin-dashboard/site-system/records/actions-log/actions-log.component';
import { OfflineSyncService } from "./offline-sync.service";
import { AuthService } from "src/app/services/auth.service";
import { User } from "src/app/auth/user";

export interface ServiceNote {
    description: string;
    createdAt: number;
    createdBy: string;
    systemId: string;
    siteId: string;
    companyId: string;
    deleted?: boolean;
}

@Injectable({ providedIn: 'root' })
export class SystemService {
    companyId: string // "E1DJZVRUmaa7azB16NdQ"
    siteId: string;
    systemId: string;
    vmMachienArr;
    transactionRecordArr = []
    stockControll = [];
    transactionRecordArrChanged = new Subject
    vmMachineChanged = new Subject<[]>();
    stockControllChanged = new Subject;
    route: ActivatedRoute;
    openLending: boolean;
    user: User;
    lockerKey = "locker"//: string  = "JUtpJMBtH0GWkb9OpF8V";
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private afs: AngularFirestore,
        private config: ConfigService,
        private http: HttpClient,
        private auth: AuthService,
        private notifierService: NotificationService,
        private offlineSync: OfflineSyncService,
    ) {
        this.auth.user$.subscribe(user => this.user = user)

        window.addEventListener('online', () => {
            this.retryPendingUpdates();
        });
    }

    systemSetData(siteId: string, systemId: string) {
        this.siteId = siteId;
        this.systemId = systemId;
        let vmMachienArr = []
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .ref
            .onSnapshot((querySnapshot) => {
                vmMachienArr = []
                querySnapshot.forEach((doc) => {
                    if (doc.data()['type'] != "pickup")
                        vmMachienArr.push({
                            id: doc.id,
                            name: doc.data()['name'],
                            index: doc.data()['index'],
                            type: doc.data()['type']
                        })
                })
                vmMachienArr.sort((a, b) => a.index - b.index)
                this.vmMachienArr = vmMachienArr;
                this.vmMachineChanged.next(this.vmMachienArr);
            })

    }

    getMachines(companyId: string, siteId: string, systemId: string) {
        return this.afs.collection('company')
            .doc(companyId)
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('vmachine')
            .get();
    }

    systemGetData() {
        return this.vmMachienArr
    }

    async addSvinn(data) {

        const batch = this.afs.firestore.batch();
        data.forEach(doc => {
            if (doc['updateId']) {

                console.log("updating", doc)
                let ref = this.afs.collection('svinn').doc(doc['updateId']).ref
                batch.update(ref, { number: doc['input'], unix: moment().unix() })
            } else {
                console.log("Creating:", doc)
                let nycRef = this.afs.collection("svinn").ref.doc();
                batch.set(nycRef, doc);
            }
        })
        // Get a new write batch
        await batch.commit();
    }

    async getSvinnData(systemId: string) {

        const svinnData = await this.afs.collection('svinn')
            .ref
            .where('systemId', '==', systemId)
            .where('unix', '>=', moment().startOf('day').unix())
            .limit(1000)
            .get()

        // console.log("svinnData", svinnData.docs.map(doc => doc.data()))

        return svinnData.docs.map(doc => {
            return { doc: doc.data(), id: doc.id }
        })

    }

    getSystemDetail(systemId: string) {
        return new Promise((res, rej) => {
            let doc = this.afs.collection('system_info')
                .doc(systemId)
            doc.get().subscribe((sp) => {
                res(sp.data())
            })
        })

    }

    getSystemInfoFromNumber(number: number) {
        return this.afs.collection('system_info', ref => ref.where('number', '==', number)).get().pipe(
            map(snapshot => snapshot.docs.map((doc : any) => ({ id: doc.id, ...doc.data() })))
        );
    }

    getSystemDetail$(systemId: string) {
        return this.afs.collection('system_info')
            .doc(systemId)
            .get()
            .pipe(
                map(sp => sp.data())
            );
    }

    resetMachine(companyId, siteId: string, systemId: string, machieId) {
        // console.log(siteId, systemId, machieId)
        let doc = this.afs.collection('company')
            .doc(companyId)
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId).collection('vmachine').doc(machieId)

        doc.get().subscribe((sp) => {
            if (sp.data()['resetMachine'])
                doc.update({ resetMachine: false })
        })
        doc.update({ resetMachine: true })

    }


    readMachineFault(companyId, siteId: string, systemId: string, machieId) {
        let doc = this.afs.collection('company')
            .doc(companyId)
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId).collection('vmachine').doc(machieId)

        doc.get().subscribe((sp) => {
            if (sp.data()['readMachineFault'])
                doc.update({ readMachineFault: false })
        })
        doc.update({ readMachineFault: true })

    }



    addNewVendingMachine(values) {

        return new Promise(async (resolve, reject) => {
            let machineId = ''
            let localSystemId = ''
            let siteName = ''
            let companyName = ''
            values.needUpdate = true;
            values.index = 0;


            try {
                let systemPath = this.afs.collection('company')
                    .doc(this.config.getCompanyId())
                    .collection('sites')
                    .doc(this.siteId)
                    .collection('systems')
                    .doc(this.systemId)

                let sitePath = this.afs.collection('company')
                    .doc(this.config.getCompanyId())
                    .collection('sites')
                    .doc(this.siteId)


                let companyPath = this.afs.collection('company')
                    .doc(this.config.getCompanyId())

                let lockerCheck = await systemPath.collection('vmachine').ref.doc('locker').get();

                if (values.type === 'cal8' && lockerCheck.exists) {
                    this.notifierService.showNotification('warning', "You already have one locker to this system. Contact support");
                    return;
                }


                let ref = await systemPath.ref.get();
                let siteref = await sitePath.ref.get();
                let companyRef = await companyPath.ref.get();

                localSystemId = ref.data()['systemId'];
                siteName = siteref.data()['name'];
                companyName = companyRef.data()['name'];

                let vmRef;
                if (values.type == 'cal8') {
                    vmRef = systemPath.collection('vmachine').ref.doc('locker');
                    await systemPath.update({ lockerId: vmRef.id })

                }
                else
                    vmRef = systemPath.collection('vmachine').ref.doc()

                vmRef
                    .set(values)
                    .then(async (data) => {
                        machineId = vmRef.id;
                        await this.afs.collection('machine_mapping').
                            add({
                                companyId: this.config.getCompanyId(),
                                systemId: this.systemId,
                                siteId: this.siteId,
                                type: values.type,
                                machineId: machineId,
                                localVendingMachineId: values.code,
                                localSystemId: localSystemId,
                                systemName: ref.data()['name'],
                                siteName,
                                companyName
                            });
                        this.notifierService.showNotification('success', "Successfully Added!")
                        resolve(true);
                    })

            }
            catch (err) {
                console.log(err)
                this.notifierService.showNotification('error', "some problem happen")
                resolve(false);
            }
        })
    }

    onUpdateMachine(id: string, obj) {
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(this.siteId)
            .collection('systems')
            .doc(this.systemId)
            .collection('vmachine')
            .doc(id).update(obj).then((data) => {
                this.notifierService.showNotification('success', "Successfully updated!")
            })
    }

    deleteVendingMachine(id: string) {
        let systemPath = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(this.siteId)
            .collection('systems')
            .doc(this.systemId)

        // let element = this.vmMachienArr.find((element) => {
        //     return element.id == id;
        // });
        // if (element.type == 'cal8')
        //     systemPath.update({ lockerId: null })

        systemPath
            .collection('vmachine')
            .doc(id).delete().then((data) => {
                this.notifierService.showNotification('success', "Successfully Deleted!");
            }).catch(err => {
                this.notifierService.showNotification('error', "Some issue, please try again");
            })
    }


    transactionRecord$(siteId: string, systemId: string, dateFrom: string, dateTo: string) {
        // this.transactionRecordArr = []

        // return this.afs.collection('company').doc(this.config.getCompanyId())
        // .collection('transactions', ref=> ref.where('siteId','==',siteId).where('systemId','==',systemId).where('unix', ">=", Number(dateFrom)).where('unix', "<=", Number(dateTo)))


        return this.afs
            .collection('transactions', ref => ref.where('companyId', "==", this.config.getCompanyId()).where('siteId', "==", siteId).where('systemId', "==", systemId).where('unix', ">=", Number(dateFrom)).where('unix', "<=", Number(dateTo)))
            .snapshotChanges().pipe(map(doc => {
                return doc.map(data => {
                    return {

                        ...data.payload.doc.data() as object,
                        status: data.payload.doc.data()['status'] ? 'Successful' : 'Unsuccessful',
                        date: moment(data.payload.doc.data()['date']).tz("Europe/Oslo").format("DD.MM.YYYY HH:mm"),
                        project: data.payload.doc.data()['project'] != null ? data.payload.doc.data()['project']['id'] : 'Not assinged',
                        department: data.payload.doc.data()['department'] != null ? data.payload.doc.data()['department']['name'] : 'Not assinged',
                    }
                })
            }))

    }

    addActionLog(siteId: string, systemId: string, data) {
        // this.transactionRecordArr = []
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('actions')
            .add({ performedAt: moment().unix(), performedBy: this.user.email, ...data })

    }



    getLinks(siteId, systemId) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('links')
            .snapshotChanges().pipe(
                map(data => {
                    return data.map(doc => {
                        return {
                            ...doc.payload.doc.data(),
                            uid: doc.payload.doc.id,
                            name: doc.payload.doc.data()['name'],
                            link: doc.payload.doc.data()['link'],
                        }
                    })
                })
            )
    }

    deleteLink(siteId, systemId, linkId) {
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('links')
            .doc(linkId).delete().then(() => {

                this.notifierService.showNotification('success', "Successfully deleted!")


            }).catch((err) => {
                this.notifierService.showNotification('error', "Some problem happend! try again");
                console.log(err)
            })
    }

    async addLinks(siteId, systemId, data) {
        try {
            let result = await this.afs.collection('company')
                .doc(this.config.getCompanyId())
                .collection('sites')
                .doc(siteId)
                .collection('systems')
                .doc(systemId)
                .collection('links')
                .add(data)


            if (result)
                this.notifierService.showNotification('success', "Successfully Added!");
        } catch (error) {
            this.notifierService.showNotification('error', "Some issue happened, try again");

        }

    }

    getStockDataAll$(siteId, systemId) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('stocks')
            .doc('product_data')
            // .collection('stock_data', ref => ref.where('active', '==', true).orderBy('selection', 'desc'))
            .collection('stock_data', ref => ref.orderBy('selection', 'desc'))
            .snapshotChanges()
            .pipe(
                map(data => {
                    //  data = (data as any).sort((a,b)=>{
                    //     return a.payload.doc.data().quantity - b.payload.doc.data().quantity;
                    // })
                    // console.log(a)
                    return data.map(doc => {

                        return {
                            ...doc.payload.doc.data(),
                            uid: doc.payload.doc.id,
                            newValue: 0,
                            channelId: doc.payload.doc.id,
                            productId: doc.payload.doc.data()['productId'],
                            performedAt: moment.unix(doc.payload.doc.data()['performedAt']).format("HH:mmA, MMM D, YYYY")
                        }
                    })
                })
            )
    }

    getStockData$(siteId, systemId) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('stocks')
            .doc('product_data')
            // .collection('stock_data', ref => ref.where('active', '==', true).orderBy('selection', 'desc'))
            .collection('stock_data', ref => ref.where('active', '==', true).orderBy('selection', 'desc'))
            .snapshotChanges()
            .pipe(
                map(data => {
                    //  data = (data as any).sort((a,b)=>{
                    //     return a.payload.doc.data().quantity - b.payload.doc.data().quantity;
                    // })
                    // console.log(a)
                    return data.map(doc => {

                        return {
                            ...doc.payload.doc.data(),
                            uid: doc.payload.doc.id,
                            newValue: 0,
                            channelId: doc.payload.doc.id,
                            productId: doc.payload.doc.data()['productId'],
                            performedAt: moment.unix(doc.payload.doc.data()['performedAt']).format("HH:mmA, MMM D, YYYY")
                        }
                    })
                })
            )
    }

    setStockData(data) {
        // console.log(data)
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sales').doc(this.systemId).collection(data.unix.toString()).doc(data.uid).set(data)
    }

    addPackingList(data) {
        let batch = this.afs.firestore.batch();

        data.forEach(element => {
            let ref1 = this.afs.collection('packingList').doc().ref

            batch.set(ref1, { ...element, createdOn: moment().unix() });

        });
        batch.commit().then(() => {
            this.notifierService.showNotification('success', "Packing List is updated");
        });
    }


    updateStocks(data) {

        let batch = this.afs.firestore.batch();

        data.stockArry.forEach(element => {
            let ref1 = this.afs.collection('inventory').doc().ref

            let ref2 = this.afs.collection('company')
                .doc(this.config.getCompanyId())
                .collection('sites')
                .doc(data.siteId)
                .collection('systems')
                .doc(data.systemId)
                .collection('stocks')
                .doc('product_data')
                .collection('stock_data')
                .doc(element.channelId).ref
            batch.update(ref2, {
                companyId: data.companyId, siteId: data.siteId, systemId: data.systemId, updatedOn: moment().unix(), active: true,
                productId: element.productId,
                productName: element.name,
                maxLimit: Number(element.maxLimit),
                quantity: Number(element.quantity),
                disabled: element.disabled == true ? true : false,
                structuralQtyPerUnit: parseFloat(element.structuralQtyPerUnit),
                performedAt: moment().unix()
            });

            batch.set(ref1, { companyId: data.companyId, siteId: data.siteId, systemId: data.systemId, ...element, updatedOn: moment().unix(), createdAt: moment().unix(), performedAt: moment().unix() });

        });

        // Per-product fill state (root fillState/{systemId}) — when each product
        // was last filled and how many units the save added (net + taps). The
        // driver app's svinn suggestions read this; the driver API maintains the
        // same doc for fills done through the app.
        const byProduct = {};
        data.stockArry.forEach(element => {
            if (!element.productId) return;
            const cur = byProduct[element.productId] || { at: moment().unix(), quantity: 0, added: 0 };
            cur.quantity += Number(element.quantity) || 0;
            cur.added += Math.max(0, Number(element.newValue) || 0);
            byProduct[element.productId] = cur;
        });
        if (Object.keys(byProduct).length) {
            batch.set(this.afs.collection('fillState').doc(data.systemId).ref, {
                companyId: data.companyId, siteId: data.siteId, systemId: data.systemId,
                byProduct, updatedAt: moment().unix()
            }, { merge: true });
        }

        return batch.commit().then(() => {
            this.notifierService.showNotification('success', "Inventory is updated");
            return true;
        }).catch(err => {
            console.error(err);
            this.offlineSync.queueRequest('UPDATE_STOCKS', data);
            this.notifierService.showNotification('warning', "Update failed but saved locally. We will retry automatically.");
            return false;
        });
    }


    async retryPendingUpdates() {
        const pending = this.offlineSync.getPendingRequests();
        if (pending.length === 0) return;

        console.log(`Retrying ${pending.length} pending updates...`);
        for (const req of pending) {
            try {
                let success = false;
                if (req.type === 'UPDATE_STOCKS') {
                    // Temporarily remove from queue to avoid loops, but we'll use a better way
                    const batch = this.afs.firestore.batch();
                    const data = req.data;
                    data.stockArry.forEach(element => {
                        let ref1 = this.afs.collection('inventory').doc().ref;
                        let ref2 = this.afs.collection('company')
                            .doc(this.config.getCompanyId())
                            .collection('sites')
                            .doc(data.siteId)
                            .collection('systems')
                            .doc(data.systemId)
                            .collection('stocks')
                            .doc('product_data')
                            .collection('stock_data')
                            .doc(element.channelId).ref;
                        
                        batch.update(ref2, {
                            ...element,
                            quantity: Number(element.quantity),
                            updatedOn: moment().unix(),
                            performedAt: moment().unix()
                        });
                        batch.set(ref1, { ...element, updatedOn: moment().unix(), createdAt: moment().unix() });
                    });
                    await batch.commit();
                    success = true;
                } else if (req.type === 'UPDATE_QUANTITY') {
                    const { siteId, systemId, obj } = req.data;
                    await this.afs.collection('company')
                        .doc(this.config.getCompanyId())
                        .collection('sites')
                        .doc(siteId)
                        .collection('systems')
                        .doc(systemId)
                        .collection('stocks')
                        .doc('product_data')
                        .collection('stock_data')
                        .doc(obj.channelId)
                        .update({
                            ...obj,
                            quantity: Number(obj.quantity),
                            performedAt: moment().unix()
                        });
                    success = true;
                }

                if (success) {
                    this.offlineSync.removeRequest(req.id);
                    console.log(`Successfully retried request ${req.id}`);
                }
            } catch (e) {
                console.error(`Retry failed for request ${req.id}`, e);
                // Keep in queue for next time
            }
        }
    }



    updateInventoryData() {
        // this.getUsers(siteId)
        console.log("updating inventory")
        this.afs.collection('inventory', ref => ref.where('updatedOn', '>', 1728570391).where('vat', '>', 1).limit(10000))
            .get()
            .subscribe((doc) => {
                console.log("size", doc.size)
                doc.forEach(async data => {
                    // console.log(data.data(),data.id)
                    const date = moment(data.data()['performedAt'], 'hh:mmA, MMM DD, YYYY').unix();
                    // console.log(date)
                    await data.ref.update({ updated: true, createdAt: date, vat: 0 })

                })
            })

    }

    getAllCategories$ = () => {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('categories').snapshotChanges().pipe(map(doc => {
                return doc.map(obj => {
                    return {
                        ...obj.payload.doc.data(),
                        dbid: obj.payload.doc.id,
                    }
                })
            }))
    }

    deleteSiteCategory(id) {
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('siteCategories').doc(id).delete();
    }
    updateSiteCategory(id, data) {
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('siteCategories').doc(id).update(data);
    }

    updateTask(id, data) {
        return new Promise<any>((resolve, reject) => {
            this.afs.collection('tasks').doc(id).set(data, { merge: true }).then(doc => {
                resolve("successfully updated")
            }).catch(err => {
                console.log(err)
                reject("not updated")
            })
        })
    }


    getAllSiteCategories$ = (siteId) => {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('siteCategories', ref => ref.where('siteId', '==', siteId)).snapshotChanges().pipe(map(doc => {
                return doc.map(obj => {
                    return {
                        ...obj.payload.doc.data(),
                        sitedbid: obj.payload.doc.id,
                    }
                })
            }))
    }

    setSiteCategory = (siteId, categoryId, data) => {
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('siteCategories').add({ siteId, categoryId, ...data })
    }



    updateQuantity(siteId, systemId, obj) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection('stocks')
            .doc('product_data')
            .collection('stock_data')
            .doc(obj.channelId)
            .update({
                active: true,
                productId: obj.productId,
                productName: obj.productName,
                maxLimit: Number(obj.maxLimit),
                quantity: Number(obj.quantity),
                structuralQtyPerUnit: parseFloat(obj.structuralQtyPerUnit),
                performedAt: moment().unix()
            }).then(data => {
                return { success: true, message: "Successfully updated" };
            }).catch(err => {
                console.error(err);
                this.offlineSync.queueRequest('UPDATE_QUANTITY', { siteId, systemId, obj });
                return { success: false, message: "Failed to update. Saved locally for retry." };
            });

    }
    updateDisbale(siteId, systemId, obj) {
        console.log(siteId, systemId, obj)
        // return new Promise<any>((resolve, reject) => {

        //     this.afs.collection('company')
        //         .doc(this.config.getCompanyId())
        //         .collection('sites')
        //         .doc(siteId)
        //         .collection('systems')
        //         .doc(systemId)
        //         .collection('stocks')
        //         .doc('product_data')
        //         .collection('stock_data')
        //         .doc(obj.channelId)
        //         .update({
        //             disabled: obj.disabled
        //         }).then(data => {
        //             resolve({ success: true, message: "Successfully updated" });
        //         })
        // });

    }


    getKey() {
        return this.lockerKey;
    }





    getJSDLogs(siteId, systemId, limit) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection("jsdLogs").snapshotChanges().pipe(map(data => {
                return data.map(doc => {
                    return {
                        ...doc.payload.doc.data(),
                        id: doc.payload.doc.id
                    }

                })
            }));
    }

    getActionLogs$(siteId, systemId, limit) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection("actions", ref => {
                return ref.limit(limit).orderBy("performedAt", "desc");
            }).snapshotChanges().pipe(map(data => {
                return data.map(doc => {
                    return {
                        ...doc.payload.doc.data(),
                        id: doc.payload.doc.id
                    }

                })
            }));
    }
    getMachineLogs$(siteId, systemId, limit) {


        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection("machineStatus", ref => {
                return ref.limit(limit).orderBy("updateOn", "desc")//.where('doorStatus', '==', "0");
            }).snapshotChanges().pipe(map(data => {
                return data.map(doc => {
                    return {
                        ...doc.payload.doc.data(),
                        id: doc.payload.doc.id,
                        doorStatus: doc.payload.doc.data()['doorStatus'] == "0" ? 'Door opened' : "Door Closed",
                        lightStatus: doc.payload.doc.data()['lightStatus'] == "0" ? 'Light Off' : "Light On",
                        availablityMachine: doc.payload.doc.data()['doorStatus'] == "0" ? 'Door opened' : "Door Closed",
                        updatedOn: moment.unix(doc.payload.doc.data()['updateOn']).tz("Europe/Oslo").format("DD.MM.YYYY HH:mm")
                    }
                })
            }));
    }




    getSystemEmailList$(siteId, systemId) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .snapshotChanges()
    }

    // getInventoryData() {
    //     return this.afs.collection("inventory",ref=> ref.where('systemId',"==","eHn5DGle3VjFpWdsrYNx").orderBy('updatedOn','desc')).snapshotChanges().subscribe(data => {
    //         console.log(data)
    //     }
    //     )
    // }

    getStockFillings(siteId, systemId) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .collection("stocks")
            .doc("product_data")
            .collection("stock_fillings", ref => ref.orderBy('createdOn', 'desc').limit(200))
            .snapshotChanges();
    }

    updateEmailListForStockFiller(siteId, systemId, emailArr) {
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId)
            .update({ emailsForStockFiller: emailArr }).then(data => {
                this.notifierService.showNotification('success', "Successfully updated!");
            }).catch(err => this.notifierService.showNotification('error', "Some issue happen"))
    }


    getSystemTask(systemId, workerId) {
        return new Promise(async (res, rej) => {
            let snapShot = await this.afs.collection('tasks', ref => ref.where('systemId', '==', systemId).where('worker', '==', workerId)).get()
            snapShot.forEach(doc => {
                if (!doc.empty)
                    doc.forEach(_d => {
                        res({ id: _d.id, ..._d.data() as object })
                    })
                else
                    res("Task not found")
            })
        })

    }

    async createTask(object, taskId?) {


        console.log(object)
        console.log(taskId)
        // if (taskId) {
        //     delete object.id;
        //     let snapShot = await this.afs.collection('tasks').doc(taskId).update(object)

        // } else {
        let snapShot = await this.afs.collection('tasks').add(object)

        // }



    }

    createStockFiller(siteId, systemId) {
        return new Promise((res, rej) => {
            let obj = {
                companyId: this.config.getCompanyId(),
                siteId: siteId,
                systemId: systemId
            }

            this.http.post(environment.apiUrl + "/widgets/genrate/refrencecode", JSON.stringify(obj), this.httpOptions).subscribe(data => {

                console.log(data)
                if (data['success']) {
                    this.notifierService.showNotification('warning', data['message']);
                }
                else if (!data['status'])
                    this.notifierService.showNotification('success', "Successfully created!");
                else
                    this.notifierService.showNotification('error', "Some issue happen");

                res(true)
            })
        })


    }

    genStockFillerMail(siteId, systemId, stockFillerId) {
        let obj = {
            companyId: this.config.getCompanyId(),
            siteId: siteId,
            systemId: systemId,
            stockFillerId: stockFillerId
        }

        this.http.post(environment.apiUrl + "/widgets/genstockfillermail", JSON.stringify(obj), this.httpOptions).subscribe(data => {

            console.log(data)
            if (data['success'])
                this.notifierService.showNotification('success', data['message']);
            else
                this.notifierService.showNotification('error', "Some issue happen");
        })

    }


    updateTranaction(dbid, data) {
        console.log("updating transaction", dbid, data)
        this.afs.collection('transactions').doc(dbid).update({ ...data }).then(data => {
            // this.notifierService.showNotification('success', "Successfully updated");
        }
        ).catch(err => {
            this.notifierService.showNotification('error', "Some issue happen");
        })
    }



    addServiceNote(serviceNote: ServiceNote) {

        console.log("adding service note", serviceNote);

        this.afs.collection('service_notes')
            .add(serviceNote).then(() => {
                this.notifierService.showNotification('success', "Successfully added service note!");
            }).catch(err => {
                console.error("Error adding service note", err);
                this.notifierService.showNotification('error', "Some issue happen while adding service note");
            });
    }

    getServiceNotes$(systemId: string) {
        return this.afs.collection('service_notes', ref => ref.where('systemId', '==', systemId).orderBy('createdAt', 'desc'))
            .snapshotChanges().pipe(map(data => {
                return data.map(doc => {
                    return {
                        ...doc.payload.doc.data() as object,
                        id: doc.payload.doc.id
                    }
                })
            })
        );
    }

    deleteServiceNote(id: string) {
        this.afs.collection('service_notes').doc(id).delete().then(() => {
            this.notifierService.showNotification('success', "Successfully deleted service note!");
        }).catch(err => {
            console.error("Error deleting service note", err);
            this.notifierService.showNotification('error', "Some issue happen while deleting service note");
        });
    }

}